import React from 'react';
import { NgoBlockView } from './NgoBlockView';
import { Enum_Userspermissionsuser_Ong } from '../../../../graphql/generated/graphql';

export interface NgoBlockProps {
  onClick: () => void;
  ong: Enum_Userspermissionsuser_Ong | null;
}

export const NgoBlock = ({ onClick, ong }: NgoBlockProps) => {
  return <NgoBlockView onClick={onClick} ong={ong} />;
};
